import React from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { Translate } from "react-localize-redux";
import "./styles.scss";

const CATEGORIES = {
  Home: <Translate id="Home" />,
  Work: <Translate id="Work" />,
  Mobile: <Translate id="Mobile" />
};

export class GeneralMultiItemDropDown extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.items !== null && !prevState.selectedItem) {
      return { selectedItem: nextProps.items[0] };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      selectedItem: null
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const { dropdownOpen, selectedItem } = this.state;
    const {
      items,
      itemDetailField,
      itemLabelField,
      renderItemDetail,
      staticItemLabel
    } = this.props;

    return (
      !!items.length && (
        <div className="row">
          <div className="col-2 general-dropdown-label-container">
            <span className="general-dropdown-label">
              {staticItemLabel
                ? staticItemLabel
                : CATEGORIES[selectedItem[itemLabelField]] ||
                  selectedItem[itemLabelField]}
              :
            </span>
          </div>
          <div className="col-9">
            <Dropdown isOpen={dropdownOpen} toggle={this.toggle}>
              <DropdownToggle
                caret={items.length > 1}
                className="general-dropdown-toggle"
              >
                <span>
                  {renderItemDetail
                    ? renderItemDetail(selectedItem)
                    : selectedItem[itemDetailField]}
                </span>
              </DropdownToggle>
              <DropdownMenu className="general-dropdown-menu">
                {items.map(item => (
                  <DropdownItem
                    className="general-dropdown-item"
                    key={`${Math.random()}`}
                    onClick={() => this.setState({ selectedItem: item })}
                  >
                    {this.props.renderDropDownItemLabel(item)}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      )
    );
  }
}

GeneralMultiItemDropDown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  itemDetailField: PropTypes.string,
  itemLabelField: PropTypes.string,
  renderItemDetail: PropTypes.func,
  renderDropDownItemLabel: PropTypes.func,
  staticItemLabel: PropTypes.string
};

GeneralMultiItemDropDown.defaultProps = {
  renderItemDetail: null,
  staticItemLabel: null
};

export default GeneralMultiItemDropDown;



// WEBPACK FOOTER //
// ./src/components/forms/GeneralMultiItemDropDown/GeneralMultiItemDropDown.jsx